function InvoiceLoadingView() {
  return (
      <>
        LOADING
      </>
  );
}

export default InvoiceLoadingView;
